'use client';
import { ErrorSummary } from './error-summary.js';
import { ErrorSummaryHeading } from './error-summary-heading.js';
import { ErrorSummaryItem } from './error-summary-item.js';
import { ErrorSummaryLink } from './error-summary-link.js';
import { ErrorSummaryList } from './error-summary-list.js';

/**
 * ErrorSummary component, used to display a list of errors.
 *
 * @example
 * <ErrorSummary>
 *   <ErrorSummary.Heading>Heading</ErrorSummary.Heading>
 *   <ErrorSummary.List>
 *     <ErrorSummary.Item>
 *       <ErrorSummary.Link href='#'>Error 1</ErrorSummary.Link>
 *     </ErrorSummary.Item>
 *     <ErrorSummary.Item>
 *       <ErrorSummary.Link href='#'>Error 2</ErrorSummary.Link>
 *     </ErrorSummary.Item>
 *   </ErrorSummary.List>
 * </ErrorSummary>
 */
const ErrorSummaryComponent = Object.assign(ErrorSummary, {
    Heading: ErrorSummaryHeading,
    Item: ErrorSummaryItem,
    List: ErrorSummaryList,
    Link: ErrorSummaryLink,
});
ErrorSummaryComponent.Item.displayName = 'ErrorSummary.Item';
ErrorSummaryComponent.Heading.displayName = 'ErrorSummary.Heading';
ErrorSummaryComponent.List.displayName = 'ErrorSummary.List';
ErrorSummaryComponent.Link.displayName = 'ErrorSummary.Link';

export { ErrorSummaryComponent as ErrorSummary, ErrorSummaryHeading, ErrorSummaryItem, ErrorSummaryLink, ErrorSummaryList };
